<template>
    <app-modal
        :show="show"
        @close="close"
        width="lg:w-7/12"
    >
        <template slot="header">Generate Invoice for {{ route.meta.tenantName }}</template>
        <template slot="body">
            <date-picker 
                v-model="dateFilter"
                format="MMM DD, YYYY"
                value-type="YYYY-MM-DD"
                placeholder="Date Filter" 
                range
                inline
            />
            <div class="flex items-center justify-end mt-5">
                <app-button 
                    class="btn-white"
                    @click="close"
                    :disable="downloading"
                >Cancel</app-button>
                <app-button 
                    class="btn-blue ml-2"
                    @click="generateInvoice"
                    :loading="downloading"
                >Download Invoice</app-button>
            </div>
        </template>
    </app-modal>
</template>

<script>
    import DatePicker from '@dluague/vue-datepicker';
    import { startOfMonth, endOfMonth, format } from 'date-fns';
    import Http from '@/helpers/Http';

    export default {
        components: {
            DatePicker,
        },
        props: {
            show: {
                type: Boolean,
                required: true,
            },
            route: {
                type: Object,
                required: true,
            }
        },
        data() {
            return {
                dateFilter: [format(startOfMonth(new Date), 'yyyy-MM-dd'), format(endOfMonth(new Date), 'yyyy-MM-dd')],
                downloading: false,
            }
        },
        methods: {
            close() {
                this.$emit('update:show', false);
                this.$emit('close');
            },
            generateInvoice() {
                this.downloading = true;
                Http.get(`pbxware/invoices/${this.route.meta.tenantId}`, {
                    params: {
                        startDate: this.dateFilter[0],
                        endDate: this.dateFilter[1],
                    },
                    responseType: 'blob',
                })
                .then(response => {
                    this.downloading = false;
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', `${this.route.meta.tenantName}-invoice.pdf`);
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                })
                .catch(({ response }) => {
                    this.downloading = false;
                })
            }
        }
    }
</script>